import { render, staticRenderFns } from "./UpdateTemplate.vue?vue&type=template&id=3843ce6d&"
import script from "./UpdateTemplate.vue?vue&type=script&lang=js&"
export * from "./UpdateTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports